<template>
  <main role="main">
    <banner @menu="toggleMenu" />
    <side-menu :opened="menuDisplayed" @close="toggleMenu">
      <ul slot="content" class="side-menu-content">
        <li><router-link to="/" @click.native="toggleMenu()">Home</router-link></li>
        <li><router-link to="/components" @click.native="toggleMenu()">Typography</router-link></li>
        <li><router-link to="/components/modalexample" @click.native="toggleMenu()">Modal</router-link></li>
        <li><router-link to="/components/contextmenuexample" @click.native="toggleMenu()">Context Menu</router-link></li>
        <li><router-link to="/components/sidemenuexample" @click.native="toggleMenu()">Side Menu</router-link></li>
        <li><router-link to="/components/toggleswitchexample" @click.native="toggleMenu()">Toggle switch</router-link></li>
        <li><router-link to="/components/listexample" @click.native="toggleMenu()">List</router-link></li>
        <li><router-link to="/components/cardexample" @click.native="toggleMenu()">Card</router-link></li>
        <li><router-link to="/components/setupexample" @click.native="toggleMenu()">Advisor Setup</router-link></li>
        <li><router-link to="/components/inviteclientexample" @click.native="toggleMenu()">Invite Client</router-link></li>
        <li><router-link to="/components/overviewexample" @click.native="toggleMenu()">Overview</router-link></li>
        <li><router-link to="/components/revenueexample" @click.native="toggleMenu()">Revenue</router-link></li>
        <li><router-link to="/components/notificationexample" @click.native="toggleMenu()">Notification</router-link></li>
        <li><router-link to="/components/datepickerexample" @click.native="toggleMenu()">Date Picker</router-link></li>
        <li><router-link to="/components/accordionexample" @click.native="toggleMenu()">Accordion</router-link></li>
        <li><router-link to="/components/accountgraphexample" @click.native="toggleMenu()">Account Graph</router-link></li>
        <li><router-link to="/components/tabsexample" @click.native="toggleMenu()">Tabs</router-link></li>
      </ul>
    </side-menu>
    <router-view />
  </main>
</template>

<script>
import { banner, sideMenu } from '@/components/layout';

export default {
  components: { banner, sideMenu },
  data() {
    return {
      menuDisplayed: false,
    };
  },
  methods: {
    toggleMenu() {
      this.menuDisplayed = !this.menuDisplayed;
    },
  },
};
</script>

<style lang="scss" scoped>
header { border-bottom: 1px solid $pearl-300; }

.side-menu-content {
  li {
    border: 0;
    padding: 0;
  }

  a {
    display: block;
    width: 100%;
    padding: 0.5rem 3rem;
    text-decoration: none;
    color: $black;
    &:hover, &:focus {
      color: $primary-500;
      background: $bg-50;
    }
  }
}
</style>
